import { StringValue } from './StringValue';

export class AbsoluteDateValue extends StringValue {}
